module.exports = __webpack_public_path__ + "media/Video 8.7f00cd4c.mp4";